'use strict';

exports.__esModule = true;
var BOOTSTRAP = exports.BOOTSTRAP = 'iframe-bootstrap';
var ERROR = exports.ERROR = 'iframe-error';
var CALL = exports.CALL = 'iframe-call';
var RESPONSE = exports.RESPONSE = 'iframe-response';